export default "__VITE_ASSET__9622bf3d__"